module.exports = __webpack_public_path__ + "static/img/liucheng.9893610.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/liucheng.png
// module id = Chv6
// module chunks = 1